// /src/brand.js
import horizon from './brands/horizon';

const activeBrand = process.env.REACT_APP_BRAND || null;

export default activeBrand === "horizon" ? horizon : null;
